module.exports = __webpack_public_path__ + "img/tools.b49737a.svg";